import { IconName, icon } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Chapter as C } from "@mikros/library";

import {
  Checkbox,
  CheckboxChangeEvent,
  TextArea,
  TextAreaChangeEvent,
} from "@progress/kendo-react-inputs";
import React, { useEffect, useRef, useState } from "react";
import { SortableItemUIProps } from "@progress/kendo-react-sortable";
import { Tooltip, Whisper } from "rsuite";
import { useIntl } from "react-intl";

export interface ChapterProps extends SortableItemUIProps {
  handleChapter: (e: C) => void;
  handleChecked: (chapterId: string) => void;
  reqListChapters: string[];
  enableDrag: boolean;
  handleEnableDrag: (e: boolean) => void;
}

export function ChapterData(props: ChapterProps) {
  console.log("inside the file chapter data");

  const intl = useIntl();

  const { style, attributes, dataItem, forwardRef } = props;
  const [show, setShow] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [chapterData, setChapterData] = useState<C>(dataItem);
  const [chapterName, setChapterName] = useState<string>(
    props.dataItem.chapterName
  );

  console.log("checked value", checked);

  console.log(
    "request list chapter data item",
    props.reqListChapters.includes(dataItem.chapterId)
  );
  console.log("chapterData", chapterData);
  const chapterNameButton = document.getElementById("chapterNameDiv");

  const viewChapter = (
    <Tooltip
      className="bg-mk-primary-bright text-white"
      style={{ zIndex: 99999 }}
    >
      <div>{`${intl.formatMessage({
        id: "courses.gneratedChapter.viewChapter",
      })}`}</div>
    </Tooltip>
  );

  useEffect(() => {
    console.log("inside use effect of check");
    setChapterData(dataItem);
    if (props.reqListChapters.includes(dataItem.chapterId)) {
      console.log("dsn1,hello i am checked");
      setChecked(true);
    } else {
      console.log("dsn1,sorry not checked");
      setChecked(false);
    }
  }, [dataItem]);

  useEffect(() => {
    props.handleEnableDrag(props.enableDrag);
  }, [props.enableDrag]);

  const sampleRef = useRef();

  const handleChangeData = (e: TextAreaChangeEvent) => {
    let chpt = { ...chapterData };
    chpt.description = e.value;
    props.handleChapter(chpt);
  };

  const handleChangeChapterName = () => {
    let chpt = { ...chapterData };
    chpt.chapterName = chapterName;
    props.handleChapter(chpt);
  };

  return (
    <div
      ref={props.enableDrag ? forwardRef : sampleRef}
      {...attributes}
      style={
        props.enableDrag
          ? {
              ...style,
            }
          : {}
      }
      className="mx-2"
    >
      {/* <div
        className={`w-full mb-4 bg-mk-primary-20 ${
          show ? "rounded-3xl" : "rounded-full hover:shadow-xl"
        } space-y-3 px-5 p-3 flex flex-col justify-center items-start`}
      > */}

      <div
        className={`w-full mb-4 
    ${checked ? "bg-mk-primary-50" : "bg-mk-primary-20"} 
    ${show ? "rounded-3xl" : "rounded-full hover:shadow-xl"} 
    space-y-3 px-5 p-3 flex flex-col justify-center items-start`}
      >
        <div
          className="w-full flex justify-between items-center"
          onClick={() => props.handleEnableDrag(false)}
        >
          <div className="flex place-items-center space-x-2 justify-center items-center">
            <div>
              <Checkbox
                value={checked}
                onChange={(e: CheckboxChangeEvent) => {
                  setShow(e.value);
                  setChecked(e.value);
                  console.log("The chapter Id is", chapterData.chapterId);
                  props.handleChecked(chapterData.chapterId);
                }}
                disabled={chapterData.chapterName === ""}
              ></Checkbox>
            </div>
            <FontAwesomeIcon
              icon={["far", "fa-arrows-up-down-left-right" as IconName]}
              className="h-4 w-4 hover:cursor-grab mx-3 text-mk-primary-bright"
              onMouseEnter={(e) => {
                handleChangeChapterName();
                e.stopPropagation();
                props.handleEnableDrag(true);
              }}
            />
            <input
              id={"chapterDiv"}
              // className="editable-div p-1 bg-mk-primary-50 rounded-lg md:text-sm sm:text-[12px] px-2"
              className={`editable-div p-1 rounded-lg md:text-sm sm:text-[12px] px-2 
                ${
                  checked
                    // ? "bg-mk-primary-bright text-white"
                    ? "bg-mk-primary font-bold"
                    : "bg-mk-primary-50 font-bold"
                }`}
              onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                setChapterName(event.target.value);
              }}
              onBlur={() => {
                handleChangeChapterName();
              }}
              onMouseEnter={(e) => {
                props.handleEnableDrag(false);
              }}
              value={chapterName}
            />
          </div>
          {checked ? (
            <Whisper
              placement="top"
              controlId="control-id-hover"
              trigger="hover"
              speaker={viewChapter}
            >
              <div onClick={() => setShow(!show)}>
                <FontAwesomeIcon
                  icon={["fas", "fa-play" as IconName]}
                  className={`h-4 w-4 mx-3 hover:cursor-pointer 
                  text-mk-primary-bright
                  ${show ? "rotate-90" : ""}`}
                  onClick={() => props.handleEnableDrag(false)}
                />
              </div>
            </Whisper>
          ) : (
            <></>
          )}
        </div>
        <div className={show ? "rounded-full w-[50%]" : "hidden"}>
          <div className="flex items-center">
            <TextArea cols={90} rounded={"large"} onChange={handleChangeData}>
              {chapterData.description}
            </TextArea>
          </div>
        </div>
      </div>
    </div>
  );
}
